import { RibGateway } from './rib-gateway.interface';
import { FixMe } from '@greenkub-fronts/shared/interface';

export const initRibAPI = (apiSlice: FixMe, gateway: RibGateway) => {
  apiSlice.injectEndpoints({
    endpoints: (builder: FixMe) => ({
      getRibs: builder.query({
        query: gateway.getRibs,
        providesTags: ['Rib'],
      }),
      changeCurrentRib: builder.mutation({
        query: gateway.changeCurrentRib,
        invalidatesTags: ['Rib'],
      }),
    }),
    overrideExisting: false,
  });
};

export interface RibSliceType {
  useGetRibsQuery: FixMe;
  useChangeCurrentRibMutation: FixMe;
}
